import { authorizedAxios } from 'config/axios';

export const fetchFormatters = () => {
  return authorizedAxios.get(`/formatters`);
};
